import type { AxiosError } from 'axios';

import { type ApiErrorResponse } from './types';

export function getExceptionMessage(exception: unknown) {
  if (typeof exception === 'string') {
    return exception;
  }

  if (exception instanceof Error) {
    return exception.message;
  }

  if (
    typeof exception === 'object' &&
    !Array.isArray(exception) &&
    exception &&
    'error' in exception
  ) {
    return (exception.error as ApiErrorResponse).message;
  }

  return 'An error has occured with unrecognized format';
}

export function extractFromAxiosError(error: AxiosError) {
  const correlationId = error.config?.headers['x-correlation-id'] as
    | string
    | undefined;
  const responseData = error.response?.data as Record<string, unknown>;
  const requestUrl = error.config?.url;

  return { correlationId, requestUrl, responseData };
}

export function addNonEnumerableProperty(
  obj: object,
  name: string,
  value: unknown
): void {
  Object.defineProperty(obj, name, {
    configurable: true,
    value,
    writable: true,
  });
}
